import { lazyPopoutMailReadingPaneUtil } from 'owa-mail-popout-reading-pane/lib/lazyFunctions';
import { popoutProjectionMountedPromise } from 'owa-popout-v2/lib/store/parentStore';
import { convertRestIdToEwsId } from 'owa-identifiers';

export interface MailReadRouteParameters {
    itemId?: string;
}

export default async function mailReadRouteHandler(
    parameters: MailReadRouteParameters
): Promise<void> {
    const itemId = parameters.itemId;

    if (itemId) {
        await popoutProjectionMountedPromise;

        const decodedEwsId = convertRestIdToEwsId(decodeURIComponent(itemId));
        lazyPopoutMailReadingPaneUtil.importAndExecute(
            decodedEwsId,
            undefined /*conversationId*/,
            undefined /*internetMessageId*/,
            undefined /*mailboxInfo*/,
            undefined /*data*/,
            undefined /*freezeDryId*/
        );
    }
}
